export default __webpack_public_path__ + "static/media/ceramol-acn3-products-960.9aa39392.jpg";